import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface Story {
  id: string;
  image_url: string;
  video_url: string | null;
  media_type: string;
  caption: string | null;
  location_tag: string | null;
  created_by: string | null;
  created_at: string;
  expires_at: string;
  is_active: boolean;
  view_count: number;
  display_order: number;
}

export function useActiveStories() {
  return useQuery({
    queryKey: ["stories", "active"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("stories" as any)
        .select("*")
        .eq("is_active", true)
        .gt("expires_at", new Date().toISOString())
        .order("display_order", { ascending: true })
        .order("created_at", { ascending: false });

      if (error) throw error;
      return (data || []) as unknown as Story[];
    },
    refetchInterval: 60000, // Refetch every minute to catch expirations
  });
}

export function useAllStories() {
  return useQuery({
    queryKey: ["stories", "all"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("stories" as any)
        .select("*")
        .order("created_at", { ascending: false });

      if (error) throw error;
      return (data || []) as unknown as Story[];
    },
  });
}
